import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['list'];

  // action="target-users-list#show"
  show() {
    this.listTarget.classList.add('active');
  }
}
